import { Component, Input, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Menu } from '@com-delta-idp/mnx-skymiles-landing-page-ui';
import { MedallionBanner } from '@com-delta-omnichannel/aura';
import { StateFacade } from '../../data-access/facades/state.facade';

@Component({
  selector: 'idp-skymiles-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent implements OnInit {
  @Input() accessToken = '';
  emptyMedallionBanner: MedallionBanner = {} as MedallionBanner;
  emptyMenu: Menu = {} as Menu;

  constructor(public landingPage: StateFacade, public router: Router) {
    router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.landingPage.notification$.next();
        this.landingPage.triggerMenu();
      }
    });
  }

  ngOnInit() {
    this.landingPage.init();
  }

  redirect(link: string) {
    window.open(link, '_self');
  }
}
